export default __webpack_public_path__ + "static/media/AssignmentIcon.693ca23b.png";